export default "__VITE_ASSET__DNrpsPlk__"